import React from "react";
import Highlighter from "../../../../components/Highlighter";

const RolesDisplay = ({ roleNames, searchTerm }) => {
  if (searchTerm) {
    return (
      <Highlighter textToHighlight={roleNames} searchWords={[searchTerm]} />
    );
  }
  return <div>{roleNames}</div>;
};

export default RolesDisplay;
